import React, { useEffect } from 'react';
import { useParams,useNavigate, useLocation } from 'react-router-dom';
import { Container, Row, Col, Button, ListGroup, Card } from 'react-bootstrap';
import CryptoJS from "crypto-js";
import "./Scheme.css";
import schemedetails from "./../../../images/schemes/schemedetails.png";
import icon from "./../../../images/schemes/icon.png";
import AssociationOrder from "./../../../docs/AssociationOrder.pdf";
import UserManual from "./../../../docs/UserManual.pdf"
import CashPrizes38thNationalGamesMedallists from "./../../../docs/CashPrizes38thNationalGamesMedallists.pdf"
import CashRewardsMedallists from "./../../../docs/CashRewardsMedallists.pdf"
import ApplicationHistoryTable from './ApplicationHistoryTable';

function SchemeDetails() {
    const { encryptedSchemeId } = useParams();
    const location = useLocation();
    const { scheme } = location.state || {};
    
    let secretKey = process.env.REACT_APP_SECRET_KEY ;
    let bytes = CryptoJS.AES.decrypt(decodeURIComponent(encryptedSchemeId), secretKey);
    let schemeId = bytes.toString(CryptoJS.enc.Utf8);

    const stored = localStorage.getItem('scheme'); // stored as string
    // const scheme = JSON.parse(stored);
    // console.log(scheme);

    const navigate = useNavigate();

    // const requiredDocuments = [
    //     'Application Form',
    //     'Photo of Applicant',
    //     'Enclose 1 year sports diploma of the coach or equivalent or 6 weeks certificate or certificate of training of the National Federation of the concerned sport (for Coach)',
    //     'Details related to the training of the instructor on a stamp paper of Rs. 10(by player)',
    //     'Sports proof/evidence of participation from Uttarakhand',
    //     'Aadhaar Card',
    //     'Related Tournament Certificate'
    // ];

    // console.log('--->scheme?.id', scheme);
    let descriptionArray = [];
    try {
        // Sanitize the description string
        const sanitizedDescription = scheme?.description
            ?.replace(/'/g, '"') // Replace single quotes with double quotes
            ?.replace(/;\s*$/, ""); // Remove trailing semicolon
        // Parse the sanitized string
        descriptionArray = JSON.parse(sanitizedDescription);
        // console.log(descriptionArray);
    } catch (error) {
        console.error("Failed to parse description:", error);
    }

    const optionalDocuments = [
        'Cash Rewards - Medallists',
        'Cash Prizes – 38th National Games Medallists'
    ];

    const userManuals = [
        'Guideline to avail the e-services'
    ];

    function handleApply(){
        let secretKey = process.env.REACT_APP_SECRET_KEY ;
        let encryptedId = encodeURIComponent(CryptoJS.AES.encrypt(schemeId.toString(), secretKey).toString());
        navigate(`/grant-scheme/form/${encryptedId}`)
    }

  return (
    <div className="Scheme-container user-schemes-container">
            
            {/* Image Section */}
            
                <div className="text-center">
                    <img
                        src={schemedetails}
                        alt="Scheme Banner"
                        className="img-fluid rounded"
                    />
                </div>

            {/* Content Section */}
            <Container className="scheme-content mb-5">
                <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
                    <span className="badge mb-2 text-white"
                        style={{
                            background: "linear-gradient(90deg, #7942D1 0%, #2A1647 100%)",
                            fontSize: "0.80rem",
                            padding: "0.5em 1.5em",
                            borderRadius: "16056.36px"
                        }}>Sports Department</span>
                    {scheme?.category=="Ongoing" && <Button className="scheme-details-apply-btn" onClick={handleApply}>Apply Now</Button>}
                </div>
                <h3>Application For {scheme?.title}</h3>

                <p className="mb-4">
                    {/* {scheme.description} */}
                </p>

                <ApplicationHistoryTable scheme={scheme}/>

                <Row className="g-4">
                    <Col md={8}>
                        <Card className="p-4 shadow-sm">
                            <h5 className="fw-semibold mb-3">Required Documents</h5>
                            <ListGroup variant="flush" className="mb-4">
                                {descriptionArray && descriptionArray.map((doc, index) => (
                                    <ListGroup.Item key={index} className="border-0 ps-0 py-2 d-flex align-items-start gap-2">
                                        <img src={icon} alt="Check Icon" className="doc-check-icon" />
                                        {doc === 'Association Verification Form' ? (
                                            <div className="d-flex justify-content-between w-100">
                                            <span>Association Verification Form</span>
                                            <a href={AssociationOrder} className="fw-semibold text-decoration-underline" style={{'textAlign':'end', 'color' : '#7942D1'}} target='_blank'>Download Form</a>
                                            </div>
                                        ) : (
                                            <span>{doc}</span>
                                        )}
                                    </ListGroup.Item>
                                ))}
                            </ListGroup>

                            {/* <a href="#" className="fw-semibold text-decoration-underline" style={{'textAlign':'end', 'color' : '#7942D1'}}>Download Application Form</a> */}
                        </Card>
                    </Col>

                    <Col md={4} className="d-flex flex-column gap-4">
                        <Card className="p-4 shadow-sm">
                            <h5 className="fw-semibold mb-3">Important Documents</h5>
                            <ListGroup variant="flush">
                                {optionalDocuments.map((doc, index) => (
                                    <ListGroup.Item key={index} className="border-0 ps-0 py-2 d-flex align-items-start gap-2">
                                        <img src={icon} alt="Check Icon" className="doc-check-icon" />
                                        {doc === 'Cash Rewards - Medallists' && (
                                            <a href={CashRewardsMedallists} className="text-decoration-underline text-dark" target='_blank'>{doc}</a>
                                        ) }
                                        {doc === 'Cash Prizes – 38th National Games Medallists' && (
                                            <a href={CashPrizes38thNationalGamesMedallists} className="text-decoration-underline text-dark" target='_blank'>{doc}</a>
                                        ) }
                                        {/* <span>{doc}</span> */}
                                    </ListGroup.Item>
                                ))}
                            </ListGroup>
                        </Card>

                        <Card className="p-4 shadow-sm">
                            <h5 className="fw-semibold mb-3">User Manual</h5>
                            <ListGroup variant="flush">
                                {userManuals.map((manual, index) => (
                                    <ListGroup.Item key={index} className="border-0 ps-0 py-2 d-flex align-items-start gap-2">
                                        <img src={icon} alt="Check Icon" className="doc-check-icon" />
                                        <a href={UserManual} className="text-decoration-underline text-dark" target='_blank'>{manual}</a>
                                    </ListGroup.Item>
                                ))}
                            </ListGroup>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
  )
}

export default SchemeDetails;